import { createContext } from 'react'

import { IMagazine } from 'src/@interfaces'

export const MagazineContext = createContext<IMagazine | undefined>(undefined)

export const MagazineProvider = MagazineContext.Provider
